// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "LocationSection-module--wrapper--rV1t2";
export var mapWrapper = "LocationSection-module--mapWrapper--WjDrU";
export var mapDecorator = "LocationSection-module--mapDecorator--NFkgX";
export var infoWrapper = "LocationSection-module--infoWrapper---kVfV";
export var title = "LocationSection-module--title--TaUAf";
export var buttonWrapper = "LocationSection-module--buttonWrapper--FBFwn";
export var appointmentTypesWrapper = "LocationSection-module--appointmentTypesWrapper--ivW-B";